// extracted by mini-css-extract-plugin
module.exports = {"root":"InlineCTA_root__rTe9J","topBorder":"InlineCTA_topBorder__2rSm6","body":"InlineCTA_body__4MaLq","title":"InlineCTA_title__Mles_","link":"InlineCTA_link__j_elV"};